import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  ResponsiveContainer,
  CartesianGrid,
} from "recharts";
import { eachDayOfInterval, format, subDays, isSameDay } from "date-fns";
import pt from "date-fns/locale/pt";

const TendenciaSemanal = ({ visitas }) => {
  const agora = new Date();
  const inicioSemanaAtual = subDays(agora, 6);
  const inicioSemanaAnterior = subDays(inicioSemanaAtual, 7);

  const diasSemanaAtual = eachDayOfInterval({
    start: inicioSemanaAtual,
    end: agora,
  });
  const diasSemanaAnterior = eachDayOfInterval({
    start: inicioSemanaAnterior,
    end: subDays(inicioSemanaAtual, 1),
  });

  const formatarDia = (date) => format(date, "EEE", { locale: pt });

  const contagemPorDia = (dias, todasVisitas) => {
    return dias.map((dia) => {
      const total = todasVisitas.filter((v) =>
        isSameDay(new Date(v.createdAt), dia)
      ).length;
      return { dia: formatarDia(dia), total };
    });
  };

  const visitasSemanaAtual = contagemPorDia(diasSemanaAtual, visitas);
  const visitasSemanaAnterior = contagemPorDia(diasSemanaAnterior, visitas);

  const dados = visitasSemanaAtual.map((item, index) => ({
    dia: item.dia,
    "Semana Atual": item.total,
    "Semana Anterior": visitasSemanaAnterior[index]?.total || 0,
  }));

  return (
    <div className="bg-white rounded-2xl shadow p-4 mt-6">
      <h3 className="text-sm font-semibold text-gray-600 mb-3">
        Tendência de Visitas - Semana a Semana
      </h3>
      <ResponsiveContainer width="100%" height={250}>
        <LineChart data={dados}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="dia" fontSize={12} />
          <YAxis allowDecimals={false} fontSize={12} />
          <Tooltip />
          <Legend />
          <Line
            type="monotone"
            dataKey="Semana Atual"
            stroke="#6366F1"
            strokeWidth={2}
            dot={{ r: 3 }}
          />
          <Line
            type="monotone"
            dataKey="Semana Anterior"
            stroke="#CBD5E1"
            strokeWidth={2}
            dot={{ r: 3 }}
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
};

export default TendenciaSemanal;
